export default __webpack_public_path__ + "static/media/Sports.bbc1b175.svg";